import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pendingActions: [],
  notifiedActionIds: [],
  lastNotificationTime: null,
  notificationShownInSession: [],
  notificationsSnoozedUntil: null,
  isNotificationsSnoozed: false,
  reviewPromptShown: [],
  unverifiedEmailDialogDismissed: false,
};

const notifierDataSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setPendingActions: (state, action) => {
      state.pendingActions = action.payload;
    },
    markActionNotified: (state, action) => {
      const actionId = action.payload;
      if (!state.notifiedActionIds.includes(actionId)) {
        state.notifiedActionIds.push(actionId);
      }
      state.lastNotificationTime = new Date().toISOString();
    },
    clearNotifiedActions: (state) => {
      state.notifiedActionIds = [];
    },
    setNotificationShownInSession: (state, action) => {
      state.notificationShownInSession = action.payload;
    },
    clearNotificationShownInSession: (state) => {
      state.notificationShownInSession = [];
    },
    markReviewPromptShown: (state, action) => {
      const meetingId = action.payload;
      if (!state.reviewPromptShown.includes(meetingId)) {
        state.reviewPromptShown.push(meetingId);
      }
    },
    resetTabVisibilityState: (state) => {},
    setNotificationSnooze: (state, action) => {
      state.notificationsSnoozedUntil = action.payload;
      state.isNotificationsSnoozed = action.payload > Date.now();
    },
    clearNotificationSnooze: (state) => {
      state.notificationsSnoozedUntil = null;
      state.isNotificationsSnoozed = false;
    },
    dismissUnverifiedEmailDialog: (state) => {
      state.unverifiedEmailDialogDismissed = true;
    },
    resetUnverifiedEmailDialog: (state) => {
      state.unverifiedEmailDialogDismissed = false;
    },
  },
});

export const {
  setPendingActions,
  markActionNotified,
  clearNotifiedActions,
  setNotificationShownInSession,
  clearNotificationShownInSession,
  markReviewPromptShown,
  resetTabVisibilityState,
  setNotificationSnooze,
  clearNotificationSnooze,
  dismissUnverifiedEmailDialog,
  resetUnverifiedEmailDialog,
} = notifierDataSlice.actions;

export default notifierDataSlice.reducer;
